import { Tooltip } from '@mui/material';
import { useNavigation } from '@portal/hooks/useNavigation';
import React from 'react';

interface IProps {
  text: string;
  icon: React.SVGProps<SVGSVGElement>;
  link?: string;
  linkData?: unknown;
  onClick?: () => void;
  disabled?: boolean;
  disabledMessage?: string;
}
const IconCard = ({
  icon,
  text,
  link,
  linkData,
  onClick,
  disabled,
  disabledMessage = '',
}: IProps) => {
  const navigate = useNavigation();

  return (
    <Tooltip
      title={disabled ? disabledMessage : ''}
      className={disabled ? 'icon-card-disabled' : 'icon-card'}
      placement="top"
      arrow
    >
      <div
        onClick={() => {
          if (!disabled) {
            if (link) {
              navigate(link, { state: linkData });
            }
            if (onClick) {
              onClick();
            }
          }
        }}
      >
        <div>
          <span>{icon}</span>
        </div>
        <p className="icon-card__text">{text}</p>
      </div>
    </Tooltip>
  );
};

export default IconCard;
